import { FirestoreDocument, FirestoreField } from '../../types';
import { getFieldType } from '../../utils';

export type PeekFieldType = 'array' | 'map';

export function isFieldPeekable(fieldType: FirestoreField['type']): boolean {
  return fieldType === 'array' || fieldType === 'object';
}

export function toPeekFieldType(fieldType: FirestoreField['type']): PeekFieldType {
  return fieldType === 'array' ? 'array' : 'map';
}

export interface RowCellDescriptor {
  fieldName: string;
  value: unknown;
  fieldType: FirestoreField['type'];
  isPeekable: boolean;
}

export function getRowCellDescriptors(
  document: FirestoreDocument,
  fields: string[]
): RowCellDescriptor[] {
  return fields.map((fieldName) => {
    const value = document.data[fieldName];
    const fieldType = getFieldType(value);
    const isPeekable = isFieldPeekable(fieldType);
    return { fieldName, value, fieldType, isPeekable };
  });
}
